exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/search-calendar.component.scss
// module id = ../../../../../src/app/resort-listing/search-calendar.component.scss
// module chunks = main